<template>
  <ModelCreater :title="title" :loading="isLoading" :errors="errors" :canCreate="canCreate" @create="create">
    <CreateAssetTypeStyled>
      <InputField :labelWidth="6" class="model">
        <template v-slot:input>
          <input type="text" v-model.trim="$v.model.$model" placeholder="name" />
        </template>
        <template v-slot:label>
          <span>Name</span>
        </template>
        <template v-slot:errors v-if="$v.model.$dirty">
          <div class="error" v-if="!$v.model.required">Field is required</div>
          <div class="error" v-if="!$v.model.minLength">Field must have at least {{ $v.model.$params.minLength.min }}</div>
          <div class="error" v-if="!$v.model.isUnique">{{ $tc('messages.notUnique') }}</div>
        </template>
      </InputField>
      <InputField :labelWidth="9" class="symbol">
        <template v-slot:input>
          <input type="text" v-model.trim="$v.symbol.$model" placeholder="short name" />
        </template>
        <template v-slot:label>
          <span>Short Name</span>
        </template>
        <template v-slot:errors v-if="$v.symbol.$dirty">
          <div class="error" v-if="!$v.symbol.required">Field is required</div>
        </template>
      </InputField>
    </CreateAssetTypeStyled>
  </ModelCreater>
</template>

<script>
import { styled } from '@egoist/vue-emotion'
import ModelCreater from '@/components/misc/ModelCreater'
import { InputField } from '@common/components'
import { required, minLength } from 'vuelidate/lib/validators'

import ASSET_TYPES_QUERY from '#/graphql/assetTypes/assetTypes.gql'
import CREATE_ASSET_TYPE_MUTATION from '#/graphql/assetTypes/createAssetType.gql'

const CreateAssetTypeStyled = styled('div')`
  display: grid;
  grid-template-columns: 1fr;
  grid-auto-rows: minmax(3rem, min-content);
  grid-gap: 1rem;
  align-items: center;
  padding: 1rem;
`

export default {
  components: {
    CreateAssetTypeStyled,
    ModelCreater,
    InputField,
  },
  data() {
    return {
      model: '',
      symbol: '',
      errors: [],
      assetTypes: [],
      isLoading: false,
      isCreating: false,
      enableSave: false,
    }
  },
  computed: {
    title() {
      return `Create Asset Type`
    },
    canCreate() {
      return !this.$v.$invalid && !this.isCreating
    },
  },
  validations: {
    model: {
      required,
      minLength: minLength(3),
      isUnique() {
        const found = this.assetTypes.find(item => item.name.toLowerCase() === this.model.toLowerCase())
        if (found) {
          return false
        }
        return true
      },
    },
    symbol: {
      required,
    },
  },
  methods: {
    async create() {
      this.isCreating = true
      const resp = await this.$apollo.mutate({
        mutation: CREATE_ASSET_TYPE_MUTATION,
        variables: {
          data: {
            name: this.model,
            symbol: this.symbol,
          },
        },
      })
      this.isCreating = false
      const id = resp?.data?.createAssetType?.id
      if (resp) {
        this.$emit('reload')
        this.$router.push({
          name: 'assetTypes',
          params: {
            id,
          },
        })
      }
    },
  },
  apollo: {
    assetTypes: {
      query: ASSET_TYPES_QUERY,
    },
  },
}
</script>
